import { useEffect } from 'react'
import { Modal, Button } from 'antd'
import classNames from 'classnames'
import ActionBtn from '@/components/TableWidgets/ActionBtn'
import Action from '@/components/Action'
import styles from './index.less'
import useMain from './hooks/useMain'

const ActionButton = Action(Button)

const bodyStyles = {
    padding: 0
}

export default props => {
    const store = useMain(props)

    useEffect(() => {
        store.init()
    }, [])

    const {
        dataSource,
        inputRef,
        countdown,
        sendCount,
        sendCode,
        codes,
        activeCodeIndex,
        isCodesValid,
        submit,
        keyupHandler,
        inputChangeHandler,
        setIsFocused,
        confirmLoading
    } = store

    const renderBtn = () => {
        if (countdown <= 0) {
            if (sendCount) {
                return <ActionBtn onClick={sendCode}>重新获取验证码</ActionBtn>
            }

            return <ActionBtn onClick={sendCode}>获取验证码</ActionBtn>
        }

        return (
            <span>
                <span className={styles.sCount}>{countdown}s</span>后重新获取
            </span>
        )
    }

    return (
        <Modal
            title="授权验证"
            width={480}
            keyboard={false}
            bodyStyle={bodyStyles}
            {...props}
            footer={
                <>
                    <ActionButton onClick={props.onCancel}>取消</ActionButton>
                    <ActionButton type="primary" disabled={!isCodesValid} loading={confirmLoading} onClick={submit}>
                        确定
                    </ActionButton>
                </>
            }
        >
            <label
                className={styles.labelWrapper}
                htmlFor="j-sms-code-input"
                onKeyDown={e => {
                    // 如果按下的是回车键且验证码有效，则提交
                    if (e.key === 'Enter' && isCodesValid) {
                        e.preventDefault()
                        submit()
                    }
                }}
                onMouseDown={e => {
                    // 阻止点击label内的元素触发input的onBlur
                    e.preventDefault()
                }}
            >
                <div className={styles.content}>
                    <div className={styles.desc}>{dataSource?.message}</div>
                    <div className={styles.numBox}>
                        {codes.map((digit, index) => {
                            const isActive = activeCodeIndex === index

                            return (
                                <div
                                    key={index}
                                    className={classNames(styles.num, {
                                        [styles.isActive]: isActive
                                    })}
                                >
                                    {digit}
                                    {isActive ? <div className={styles.activeLine} /> : null}
                                </div>
                            )
                        })}
                        <input
                            ref={inputRef}
                            id="j-sms-code-input"
                            className={styles.input}
                            type="number"
                            onMouseDown={e => e.stopPropagation()}
                            onKeyUp={keyupHandler}
                            onChange={inputChangeHandler}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                        />
                    </div>
                    <div className={styles.btnWrap}>{renderBtn()}</div>
                </div>
            </label>
        </Modal>
    )
}
